const apiUrl = process.env.REACT_APP_AUNE_API_URL;

export default apiUrl;